import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { name: '应用搭建', path: '/category/app-building' },
      { name: '自动化流程', path: '/category/automation' },
      { name: '网站建设', path: '/category/website' },
      { name: '数字化转型', path: '/category/digital-transformation' },
    ],
  },
  resources: {
    title: '资源',
    links: [
      { name: '帮助文档', path: '#' },
      { name: 'API参考', path: '#' },
      { name: '视频教程', path: '#' },
      { name: '社区论坛', path: '#' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '联系我们', path: '/about#contact' },
      { name: '加入我们', path: '#' },
      { name: '合作伙伴', path: '#' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="text-2xl font-heading font-bold text-foreground-950">无码</span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              新一代低代码/无码开发平台，<br />
              让每个人都能创造数字化价值。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="GitHub">
                <i className="ri-github-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{section.title}</h4>
              <ul className="flex flex-col gap-3">
                {section.links.map((link) => (
                  <li key={link.name}>
                    {link.path.startsWith('/') ? (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.name}
                      </Link>
                    ) : (
                      <a
                        href={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-200/60 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 无码. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}